<template>
  <!-- 查看统计 -->
  <div class="container">
    <Header />
    <div class="statistics_content">
      <div class="title">{{ sectionName }}</div>
      <div class="tab">
        <div class="selection">
          <div
            class="selection_one"
            :class="type == 1 ? 'is_select' : 'no_select'"
            @click="showNewGoodsTab"
          >
            章节练习情况
          </div>
          <div
            class="selection_two"
            :class="type == 2 ? 'is_select' : 'no_select'"
            @click="showOftenRouteTab"
          >
            常见错题
          </div>
        </div>
        <div class="tab_content1" v-if="type == 1">
          <div class="practice">
            <div class="total">
              <span class="time">{{ statisticsData.times }}</span>
              <span class="name">总训练次数</span>
            </div>
            <div class="total">
              <span class="time">{{ statisticsData.longOfTime }}</span>
              <span class="name">总训练时长</span>
            </div>
            <div class="total">
              <span class="time">{{ statisticsData.correct}}%</span>
              <span class="name">正确率</span>
            </div>
            <div class="total">
              <span class="time">{{ statisticsData.avgLongOfTime }}</span>
              <span class="name">平均训练时长</span>
            </div>
          </div>
          <div class="data_list">
            <el-table :data="statisticsData.data" border style="width: 100%">
              <el-table-column
                prop="comment"
                align="center"
                label="\"
              ></el-table-column>
              <el-table-column
                prop="longOfTime"
                align="center"
                label="训练时长"
              ></el-table-column>
              <el-table-column
                prop="correct"
                align="center"
                label="正确率"
              ></el-table-column>
              <el-table-column
                prop="createTime"
                align="center"
                label="训练时间"
              ></el-table-column>
              <el-table-column
                align="center"
                label="操作">
				  <template slot-scope="scope">
					  <a style="color:#7099f9;cursor: pointer;" @click="showLogDetail(scope.row.sectionId, scope.row.createTime)">查看详情</a>
				  </template>
			  </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="tab_content2" v-if="type == 2">
          <div class="error" v-if="!wrongTopicData.length">
            <img src="../../src/assets/images/icon1.png" alt />
            <P>暂无数据</P>
          </div>
          <div class="topic_step2" id="topic_step2">
            <div v-for="(item, index) in wrongTopicData" :key="index">
              <div class="topic_content">
				<div v-if="item.times" style="color:red;">错误次数：{{item.times}}次</div>
                <div class="topic_title">
                  <div class="content_html" v-html="item.content"></div>
                </div>
                  <div class="answer_div">
                    <span>正确答案：</span>
                    <span v-for="(a, i) in item.answer.split(';')" :key="'i'+i">
                      <span class="answer">{{ a }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <Footer />
	  <div>
		  <el-dialog title="训练历史详情" :visible.sync="dialogVisible" width="690px" :before-close="handleClose" >
			  <div>
				  <div v-for="(item, index) in logDetailData" :key="index">
					  <div class="topic_content">
						  <div class="topic_title">
							  <div class="content_html" v-html="item.content"></div>
						  </div>
						  <div class="answer_div" v-if="item.isRight == 0">
							  <span>正确答案：</span>
							  <span v-for="(a, i) in item.answers.split(';')" :key="'i'+i">
							    <span class="answer">{{ a }}</span>
							  </span>
						  </div>
					  </div>
				  </div>
			  </div>
			  <span slot="footer" class="dialog-footer"></span>
		  </el-dialog>
	  </div>
  </div>
</template>

<script>
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import api from "../axios/interface";
export default {
  name: "ViewStatistics",
  data() {
    return {
      index: 0,
      type: 1,
      new_goods_show: true,
      often_route_show: false,
      sectionId: this.$route.query.id,
      sectionName: this.$route.query.name,
      statisticsData: {},
      wrongTopicData: [],
	  logDetailData: [],
      dialogVisible: false,
      videoUrl: "",
    };
  },
  components: {
    Header: Header,
    Footer: Footer
  },
  mounted() {
    this.getStatisticsList();
  },
  methods: {
    showNewGoodsTab: function() {
      this.type = 1;
      this.new_goods_show = true;
      this.often_route_show = false;
    },
    showOftenRouteTab: function() {
      this.type = 2;
      this.getWrongTopicList();
      this.new_goods_show = false;
      this.often_route_show = true;
    },
    getStatisticsList() {
      this.$axios
        .get(
          api.ENSUBJECTCAPTERSTATISTICS,
          { sectionId: this.sectionId },
          { hideMessage: true }
        )
        .then(res => {
          this.statisticsData = res.result;
        })
        .catch(res => {});
    },

    handleClose() {
      this.dialogVisible = false;
    },

   showLogDetail(sectionId, createTimeStr) {
    	this.showLogDetailList(sectionId, createTimeStr)
	  	this.dialogVisible = true;
   },

    getWrongTopicList() {
      this.$axios
        .get(
          api.ENSUBJECTWRONGTOPICLIST,
          { sectionId: this.sectionId },
          { hideMessage: true }
        )
        .then(res => {
           res.result.data.map(item => {
            if (item.examType == 3) {
              item.content = item.content.replace(
                /\[Space\]/g,
                '<input type="text" disabled class="tiankong"/>'
              );
            }
          });
          this.wrongTopicData = res.result.data;
        })
        .catch(res => {});
    },
    showLogDetailList(sectionId, createTimeStr) {
      this.$axios
        .get(
          api.ENCHALLENGELOGDETAIL,
          { sectionId: sectionId,createTimeStr: createTimeStr},
          { hideMessage: true }
        )
        .then(res => {
           res.result.data.map(item => {
            if (item.type == 3) {
              item.content = item.content.replace(
                /\[Space\]/g,
                "<textarea rows=\"2\" cols=\"58\" style=\"resize:none;color:" + (item.isRight==0 ? "red;" : "green;") + "\" disabled class=\"tk_textarea\">" + item.studentAnswer + "</textarea>"
              );
            } else {
				item.content = item.content.replace(
					/\[Space\]/g,
					"<input type=\"text\" disabled class=\"tiankong\" style=\"color:" + (item.isRight==0 ? "red;" : "green;") + "\" value=\"" + item.studentAnswer + "\"/>"
				);
			}
          });
          this.logDetailData = res.result.data;
        })
        .catch(res => {});
    }
  },
  filters: {
    computedNum(val) {
      let option = "";
      switch (Number(val)) {
        case 0:
          option = "A";
          break;
        case 1:
          option = "B";
          break;
        case 2:
          option = "C";
          break;
        case 3:
          option = "D";
          break;
        case 4:
          option = "E";
          break;
        case 5:
          option = "F";
          break;
        case 6:
          option = "G";
          break;
        case 7:
          option = "H";
          break;
        default:
          option = "";
          break;
      }
      return option;
    }
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 1665px;
  margin-left: -223px;
  background-color: #fff;
}
.statistics_content {
  width: 1056px;
  margin: 90px 50px 0 50px;
  height: auto;
  text-align: center;
  border-radius: 4px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  .title {
    height: 37px;
    line-height: 37px;
    font-size: 32px;
    color: #333333;
    text-align: center;
    padding-top: 65px;
    padding-bottom: 72px;
  }
  .tab {
    padding: 0 48px;
    .selection {
      display: flex;
      flex-direction: row;
      text-align: center;
      padding-bottom: 2px;
      border-bottom: 1px solid #ccc;
      font-size: 15px;
      color: #fff;
      .selection_one,
      .selection_two {
        width: 144px;
        height: 32px;
        font-size: 14px;
        line-height: 32px;
        border-radius: 4px 4px 0 0;
        cursor: pointer;
      }
      .no_select {
        color: #333;
        background-color: #eeeeee;
      }
      .is_select {
        color: #fff;
        background-color: #0079fe;
      }
      .selection_two {
        margin-left: 4px;
      }
    }
    .tab_content1 {
      display: flex;
      flex-direction: column;
      height: auto;
      .practice {
        display: flex;
        flex-direction: row;
        height: 120px;
        .total {
          display: flex;
          flex-direction: column;
          width: 250px;
          height: 120px;
          text-align: center;
          .time {
            font-size: 32px;
            color: #333;
            font-weight: bold;
            margin-top: 30px;
          }
          .name {
            font-size: 14px;
            color: #666666;
            margin-top: 20px;
          }
        }
      }
      .data_list {
        width: 960px;
        height: auto;
      }
    }
    .tab_content2 {
      min-height: 630px;
      height: auto;
      margin-top: 30px;
      padding-bottom: 50px;
      p {
        text-align: center;
        font-size: 20px;
        color: #ccc;
        padding-top: 10px;
      }
      .topic_step2 {
        width: 100%;
        min-height: 610px;
        background-color: #fff;
        position: relative;
        border-radius: 4px;
        text-align: left;
        .title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 56px;
          padding-left: 24px;
          background-color: #eeeeee;
          padding: 0;
          .topic_Num {
            font-size: 16px;
            color: #333;
            font-weight: 500;
          }
          .report_problem {
            margin-right: 24px;
            font-size: 14px;
            color: #666666;
            font-weight: 400;
            cursor: pointer;
            .wenhao {
              font-size: 16px;
              padding-top: 5px;
              margin-right: 5px;
            }
          }
        }
        .topic_content {
          padding: 24px 50px 24px 0px;
          color: #333333;
          line-height: 22px;
          border-bottom: 1px solid #EEEEEE;
          // &:last-of-type{
          //   border-bottom: none
          // }
          .topic_title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .content_html {
              width: 100%;
            }
            .right, .error {
              display: inline-block;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              text-align: center;
              line-height: 28px;
              color: #fff;
              font-size: 28px;
              font-weight: 600;
            }
            .right {
              background-color: #0079FE;
            }
            .error {
              background-color: #ff0000;
            }
          }
          .answer_div {
            margin-top: 25px;
            font-size: 14px;
            font-weight: 500;
            .answer {
              color: #1dc11d;
              display: inline-block;
              border-bottom: 1px solid #1dc11d;
              margin-right: 20px;
            }
          }
          .topic_option {
            margin-top: 15px;
            .select_option {
              display: flex;
              margin-top: 5px;
              span {
                &:first-of-type {
                  margin-right: 5px;
                }
              }
            }
            .select_right {
              color: #0079FE;
            }
            .select_error {
              color: #ff0000;
            }
          }
          .explain {
            margin-top: 16px;
            width: 88px;
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            text-align: center;
            border-radius: 20px;
            color: #fff;
            background-color: #1677FF;
            cursor: pointer;
          }
        }
        .next {
          position: absolute;
          bottom: 0;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          background-color: #eeeeee;
          height: 56px;
          width: 100%;
          .next_btn {
            cursor: pointer;
            padding: 0 15px;
            font-size: 14px;
            line-height: 28px;
            margin-right: 48px;
            margin: 12px 48px 12px 0;
            height: 28px;
            background-color: #0079fe;
            color: #fff;
            border-radius: 4px;
          }
          .isdisabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }
    }
  }
  .MsoNormal {
    line-height: 20px;
  }
}
</style>
